import TomSelect from "tom-select";

// Minimal Tom Select initializer
// Targets: elements with class `tom-select`
const SELECTOR = ".tom-select";

function init() {
  document.querySelectorAll(SELECTOR).forEach((el) => {
    try {
      // Only initialize once per valid element
      const isSelectOrInput = el.tagName === "SELECT" || el.tagName === "INPUT";

      // `tomselect` is the flag used internally by the Tom Select library
      const alreadyInitialized = Boolean(
        // eslint-disable-next-line no-underscore-dangle
        el._tomSelectInstance || el.tomselect,
      );

      if (isSelectOrInput && !alreadyInitialized) {
        // Basic options with Portuguese (pt-BR) translations
        // eslint-disable-next-line no-underscore-dangle
        el._tomSelectInstance = new TomSelect(el, {
          plugins: ["dropdown_input"],
          allowEmptyOption: true,
          render: {
            no_results: () =>
              '<div class="no-results">Nenhum resultado encontrado</div>',
            loading: () => '<div class="spinner"></div>',
          },
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("tom-select init error:", e);
    }
  });
}

function destroy() {
  document.querySelectorAll(SELECTOR).forEach((el) => {
    try {
      if (
        el._tomSelectInstance &&
        typeof el._tomSelectInstance.destroy === "function"
      ) {
        el._tomSelectInstance.destroy();
        delete el._tomSelectInstance;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("tom-select destroy warning:", e);
    }
  });
}

// Lifecycle bindings
document.addEventListener("DOMContentLoaded", init);
document.addEventListener("turbo:load", init);
document.addEventListener("turbo:frame-load", init);
document.addEventListener("turbo:before-cache", destroy);

// jQuery-driven events (if jQuery is present)
try {
  if (typeof window.$ !== "undefined") {
    window.$(document).on("ajaxComplete", init);
    window.$(document).on("cocoon:after-insert", init);
    window.$(document).on("shown.bs.modal", init);
  }
} catch (e) {
  // ignore
}

// Run now in case DOM already loaded
try {
  init();
} catch (e) {
  // ignore
}

export class TomSelectDefault {
  start() {
    init();
  }
}
